import styled from 'styled-components'

import { Container, Section } from '~/components/global'
import downloadBg from '~/images/download_bg.jpg'

export const StyledContainer = styled(Container)`
  max-width: 960px;
`

export const StyledSection = styled(Section)`
  padding: 100px 0;
  background-image: url(${downloadBg});
  background-position: center;
  background-size: cover;

  @media (max-width: ${(props) => props.theme.screen.lg}) {
    padding: 70px 0;
  }

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    padding: 50px 0;
  }
`

export const StoreButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .link-download {
    display: flex;
  }
  .appleBtn {
    display: inline-block;
    margin-top: 5px;
    margin-right: 16px;
    height: 51px;
    margin-left: -6px;
  }

  .googleBtn {
    display: inline-block;
  }

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    .appleBtn {
      flex: 1;
    }
    .googleBtn {
      flex: 1;
      margin-right: 0px;
    }
  }
`
